import React from "react";
import ReactPlayer from "react-player";
const ProjectSummaryView = (prop) => {

  //h-[980px] xl:h-[1100px] sm:h-[1400px]
  return (
    <div className="min-w-[360px] sm:min-w-[700px] flex flex-col justify-center items-center max-w-screen-2xl mx-auto h-auto  ">
      <div className="xl:h-[600px] min-w-[360px] sm:h-[1200px]  justify-center items-center xl:flex-row flex-col flex ">
        <div className="grid sm:w-[640px] w-[360px]  xl:h-[600px]  grid-cols-2 grid-rows-2">
          <div className="w-full   pt-10">
            <div className="flex  flex-col px-5 py-10">
              <h1 className="font-bold text-[14px] sm:text-[20px]">Title:</h1>
              <h2 className="pt-1 text-[12px] sm:text-[18px] font-semibold">{prop.title}</h2>
              <h1 className="pt-4 font-bold text-[12px] sm:text-[20px]">Game Engin:</h1>
              {/* //TODO: Remove hard coded value */}
              <h2 className="pt-1 text-[12px] sm:text-[18px] font-semibold"> {prop.gameEngin} </h2>
            </div>
          </div>

          <div className="w-full   pt-10 ">
            <div className="flex flex-col px-5 py-10">
              <h1 className="font-bold text-[14px] sm:text-[20px]">Theme:</h1>
              <h2 className="pt-1 text-[12px] sm:text-[18px] font-semibold">{prop.theme}</h2>
              <h1 className="pt-4 font-bold text-[14px] sm:text-[20px]">Duration:</h1>
              <h2 className="pt-1 text-[12px] sm:text-[18px] font-semibold">{prop.duration}</h2>
            </div>
          </div>

          <div className="w-full  col-span-2">
            <h1 className="font-bold px-5 text-[14px] sm:text-[20px]">Team:</h1>
            <div
              className={`grid gap-x-6  grid-cols-2 grid-rows-${Math.ceil(
                prop.team.length / 2
              )} px-5 py-2 `}
            >
              {prop.team.map((member, index) => {
                return (
                  <div
                    key={index}
                    className="flex  justify-between"
                  >
                    <h2 className=" text-[9px] sm:text-[14px] font-semibold">{member.name}</h2>
                    <h2 className="text-[9px] sm:text-[14px]">{member.role}</h2>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="sm:w-[640px] w-[360px] sm:h-[460px] pb-[10px] pt-[10px] ring-1 ring-slate-300 shadow-lg rounded-b-lg">
          <ReactPlayer
            url={prop.trailer}
            controls={true}
            width={"100%"}
            height={"100%"}
            showPills={false}
          />
          {/* <div className="py-4 px-8 overflow-scroll text-[12px] sm:text-[18px] xl:text-[20px] flex justify-start items-center">
            <h2>Note: {prop.inspiration}</h2>
          </div> */}
        </div>
      </div>
      <div className="px-8 sm:px-12  xl:w-[1280px] w-[360px] sm:w-[640px] flex-col flex xl:h-[300px]  py-8 xl:py-10">
        <h2 className="font-bold text-[16px] sm:text-[28px]">{prop.aboutTitle}</h2>
        {/* <p className="text-justify text-[10px] w-full  sm:text-[16px] xl:text-lg pt-2 "> */}
          {/* {prop.summary.slice(0, 700) + "..."} */}
          {prop.summary()}
        {/* </p> */}
      </div>
      <div className="flex  xl:mt-4 justify-center">
        <div className="xl:w-[1100px] w-[360px] sm:w-[640px] my-2 ring-2 ring-slate-300 shadow-lg h-[0px]"></div>
      </div>
    </div>
  );
};

export default ProjectSummaryView;
